import axios from '@/api/config';

const agentApp = {
  getAgentAppById(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/getAgentApp/` + data, {});
  },
  getAgentApp(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/getAgentApp`, { params: data });
  },
  getAgentAppList(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/getAgentAppList`, { params: data });
  },
  getAgentAppTree(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/getAgentAppTree`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentApp/pageList`, data);
  },
  addAgentApp(data) {
    return axios.post(`${process.env.BASE_URL}/agentApp/addAgentApp`, data);
  },
  updateAgentApp(data) {
    return axios.put(`${process.env.BASE_URL}/agentApp/updateAgentApp`, data);
  },
  deleteAgentApp(data) {
    return axios.delete(`${process.env.BASE_URL}/agentApp/deleteAgentApp`, { data: data });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/exportExcel`, { params: data });
  },
  agentAppOn(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/on`, { params: data });
  },
  agentAppOff(data) {
    return axios.get(`${process.env.BASE_URL}/agentApp/off`, { params: data });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/agentApp/importData`, data);
  }
}

export default agentApp;



// WEBPACK FOOTER //
// ./src/api/agentApp.js